/**
 * @generated SignedSource<<0de4301f70564880926e19b21ff2e706>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSidePanel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Bookmarks_viewer">;
  readonly " $fragmentType": "SeriesSidePanel_viewer";
};
export type SeriesSidePanel_viewer$key = {
  readonly " $data"?: SeriesSidePanel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSidePanel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSidePanel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Bookmarks_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f72f77222640289c705fa84d8319f95b";

export default node;
